import * as $ from 'jquery';

import onDocumentLoaded from "./lib/onDocumentLoaded";

import * as variables from './variables.js';
import './lib/AnimationEasing';
import "./component/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu--mobile',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Animation Trigger
import "./component/AnimationTrigger";


// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

//@ts-ignore
let StickyNav = require('./component/StickyNav.js');
StickyNav.init();

// Animations
import SiteAnimations from './component/SiteAnimations';
SiteAnimations.createInstance([
	{
		observedSelector: '#pageIntro, .employee, .pestListing, .infographicIntro',
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.acfCardListing',
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.masthead, .mediaText, #accordion, .acfInfographic, #listItemGroup, .advancedCardListing, .testimonialCarousel, #testimonialGroup, .acfTable, .sdsTable, .acfJobListing, #callToAction, .recentArticlesBlock, .socialMedia',
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.gform_wrapper',
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	}
]);


// Scrolled Navigation - Detects header after page loads
window.addEventListener('load', function () {
	const nav = document.querySelector('.headerSticky');
	if (!nav) {
		return;
	}
	const yOffset = window.pageYOffset;

	if (yOffset >= 50) {
		nav.classList.add('active');
	} else {
		nav.classList.remove('active');
	}

	window.addEventListener('scroll', function () {
		const yOffset = window.pageYOffset;

		if (yOffset >= 50) {
			nav.classList.add('active');
		} else {
			nav.classList.remove('active');
		}
	});
});

/* Silky smooth scrolling for local nav on jobPosting pages */
import SmoothScroll from './component/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
mySmoothScroll.add('a[href*="jobListing"]', {
	duration: 2500,
	easing: 'easeInOutQuad',
	offset: 100
});

// ----------------------------------------------------------------------------------------------
// Table filter interface. Used on this page: https://localhost:8443/safety-sheets/
// Docs
// 	https://github.com/koalyptus/TableFilter/wiki/1.0-Configuration
// 	https://github.com/koalyptus/TableFilter/
import TableFilter = require('tablefilter');
const table = document.querySelector('.sds');
if (table) {
	let tf = new TableFilter(table, {
		base_path: '/wp-content/themes/plaudit-theme-child/assets/tablefilter/',
		filters_row_index: 1,
		col_1: "select",
		col_3: "none",
		col_4: "none",
		col_5: "none",
		display_all_text: "- Show all -",
		sort_select: true,
		auto_filter: { delay: 500 },
		highlight_keywords: true,
		mark_active_columns: {					// Mark active columns
			highlight_column: false,			// .. but only the column header
		},
	});
	tf.init();
}

// ----------------------------------------------------------------------------------------------
// Filter Interfaces - Teams and Pests
import './lib/GenericSearch';

// ----------------------------------------------------------------------------------------------
// Service Areas - Search interface
import Autocompleter from "./component/Autocompleter";
onDocumentLoaded(document, () => {
	Autocompleter.setup();
});

import * as Ant from './component/Ant';
Ant.init();




// Carousels
// ----------------------------------------------------------------------------------------------
import imageCarousel from './component/imageCarousel';
imageCarousel();

import testimonialCarousel from './component/testimonialCarousel';
testimonialCarousel();




// Listeners - Infographic Intro
// --------------------------------------------------------------------------------------------------//
const infographicBuilding = $(".infographicIntro");
console.log(infographicBuilding);
if(infographicBuilding.length !== 0) {


	// On Page Load
	// --------------------------------------------------------------------------------------------------//
	// When document is ready, updated button (prev/next) text.
	$(document).on('ready', function() {
		const buttons = infographicBuilding.find('.infographicIntro__markerDetail');
		infographicBuilding.trigger( "updateBtnText", [buttons] );
	});
	// --------------------------------------------------------------------------------------------------//


	// Listeners
	// --------------------------------------------------------------------------------------------------//
	// If clicked on Building Marker (icon)
	$('.marker').on( "click" , function( event ) {
		const imageId = $(this).attr('data-image-id');
		infographicBuilding.trigger( "updateActive", {imageId} );
	});

	$('.btn--close').on( "click" , function( event ) {
		const imageId = $(this).attr('data-image-id');
		infographicBuilding.trigger( "updateActive", {imageId} );
	});

	$('.btn--next').on( "click" , function( event ) {
		const imageId = $(this).attr('data-image-id');
		infographicBuilding.trigger( "makeNextActive", {imageId} );
	});

	$('.btn--prev').on( "click" , function( event ) {
		const imageId = $(this).attr('data-image-id');
		infographicBuilding.trigger( "makePrevActive", {imageId} );
	});
	// --------------------------------------------------------------------------------------------------//


	// Triggers
	// --------------------------------------------------------------------------------------------------//
	// When triggered, this will updated the 'Active' class
	infographicBuilding.on( "updateActive" , function( event, data:any = null ) {
		const updateActiveMarker = infographicBuilding.find(".marker");

		for (let i = 0; i < updateActiveMarker.length; i++) {
			if(data.imageId === updateActiveMarker[i].dataset["imageId"]) {
				if ($(updateActiveMarker[i]).hasClass("active")) {
					$(updateActiveMarker[i]).removeClass("active");
				} else {
					$(updateActiveMarker[i]).addClass("active");
				}
			} else {
				$(updateActiveMarker[i]).removeClass("active");
			}
		}
	});

	infographicBuilding.on( "updateActive" , function( event, data:any = null ) {
		const updateActiveDetail = infographicBuilding.find(".infographicIntro__markerDetail");

		for (let i = 0; i < updateActiveDetail.length; i++) {
			if(data.imageId === updateActiveDetail[i].dataset["imageId"]) {
				if ($(updateActiveDetail[i]).hasClass("active")) {
					$(updateActiveDetail[i]).removeClass("active");
				} else {
					$(updateActiveDetail[i]).addClass("active");
				}
			} else {
				$(updateActiveDetail[i]).removeClass("active");
			}
		}
	});

	// When triggered, this will make the next marker/detail active
	infographicBuilding.on( "makeNextActive" , function( event ) {
		const detailItems = infographicBuilding.find(".infographicIntro__markerDetail");
		if (detailItems.length === 0) {
			return;
		}
		let nextIndex = null;
		for (let i = 0; i < detailItems.length; i++) {
			const item = detailItems[i];

			if (item.classList.contains("active")) {
				nextIndex = i + 1 === detailItems.length ? 0 : i + 1;
				break;
			}
		}
		if (nextIndex === null) {
			nextIndex = 0;
		}
		const itemToBeActive = detailItems[nextIndex];
		infographicBuilding.trigger( "updateActive", {imageId: itemToBeActive.getAttribute("data-image-id")});
	});

	// When triggered, this will make the previous marker/detail active
	infographicBuilding.on( "makePrevActive" , function( event ) {
		const detailItems = infographicBuilding.find(".infographicIntro__markerDetail");
		if (detailItems.length === 0) {
			return;
		}
		let prevIndex = null;
		for (let i = 0; i < detailItems.length; i++) {
			const item = detailItems[i];

			if (item.classList.contains("active")) {
				prevIndex = i - 1 === 0 ? detailItems.length - 1 : i - 1;
				break;
			}
		}
		if (prevIndex === null) {
			prevIndex = 0;
		}
		const itemToBeActive = detailItems[prevIndex];
		infographicBuilding.trigger( "updateActive", {imageId: itemToBeActive.getAttribute("data-image-id")});
	});

	// Updates Button (prev/next) Text
	infographicBuilding.on( "updateBtnText" , function( event, data:any[] ) {
		let prevBtn;
		let nextBtn;
		let currentPrevBtn;
		let currentNextBtn;

		for (let i = 0; i < data.length; i++) {
			if (i == 0) {
				prevBtn = $(data[data.length - 1]).attr('data-image-id')!.replace(/-/g, ' ');
				nextBtn = $(data[i + 1]).attr('data-image-id')!.replace(/-/g, ' ');
				currentPrevBtn = $(data[i]).find('.btn--prev');
				currentNextBtn = $(data[i]).find('.btn--next');
				$(currentPrevBtn).first().html(prevBtn);
				$(currentNextBtn).first().html(nextBtn);
			} else if (i == data.length - 1) {
				prevBtn = $(data[i - 1]).attr('data-image-id')!.replace(/-/g, ' ');
				nextBtn = $(data[0]).attr('data-image-id')!.replace(/-/g, ' ');
				currentPrevBtn = $(data[i]).find('.btn--prev');
				currentNextBtn = $(data[i]).find('.btn--next');
				$(currentPrevBtn).first().html(prevBtn);
				$(currentNextBtn).first().html(nextBtn);
			} else {
				prevBtn = $(data[i - 1]).attr('data-image-id')!.replace(/-/g, ' ');
				nextBtn = $(data[i + 1]).attr('data-image-id')!.replace(/-/g, ' ');
				currentPrevBtn = $(data[i]).find('.btn--prev');
				currentNextBtn = $(data[i]).find('.btn--next');
				$(currentPrevBtn).first().html(prevBtn);
				$(currentNextBtn).first().html(nextBtn);
			}
		}
	});
}


const availableAccordion = $(".faqGroup");

if(availableAccordion.length !== 0) {
	// On Page Load - Close all accoridons
	const firstAccordionActive = availableAccordion.find('.faqGroup__item');
	for (let i = 0; i < firstAccordionActive.length; i++) {
		$(firstAccordionActive[i]).removeClass("active").find(".answer").slideUp(0);
	}

	// Listeners
	$('.faqGroup__items .question').on( "click" , function( event ) {
		const questionId = $(this).parent().attr('data-question-id');
		availableAccordion.trigger("changeActive", {questionId});
	});

	// Triggers
	// Updates 'Active' Accordion
	availableAccordion.on( "changeActive" , function(event, data) {
		const updateActiveAccordion = availableAccordion.find(".faqGroup__item");

		for (let i = 0; i < updateActiveAccordion.length; i++) {
			if (data.questionId === updateActiveAccordion[i].dataset.questionId) {
				if ($(updateActiveAccordion[i]).hasClass("active")) {
					$(updateActiveAccordion[i]).removeClass("active").find(".answer").slideUp();
				} else {
					$(updateActiveAccordion[i]).addClass("active").find(".answer").slideDown();
				}
			} else {
				$(updateActiveAccordion[i]).removeClass("active").find(".answer").slideUp();
			}
		}
	});
}




const searchIcon = $(".searchIcon");

if(searchIcon.length !== 0) {
	// Toggles 'active' class on the utility menu search field
	$('.searchIcon').on( "click" , function( event ) {
		$(this).parent().toggleClass('active');
		// Puts focus on search input
		$("#searchInput").trigger("focus");
	});
}



// SharpSpring Form
document.addEventListener("DOMContentLoaded", () => {
    const chatButton = document.querySelector(".chat__button") as HTMLButtonElement;
    const chatContainer = document.querySelector(".chat__container") as HTMLElement;
    const chatEnvelopeIcon = document.querySelector(".chat-envelope-icon") as SVGElement;
    const chatCloseIcon = document.querySelector(".chat-close-icon") as SVGElement;
    const chatForm = document.getElementById("chat-form") as HTMLElement;
    const closeIcon = document.querySelector(".close-icon") as SVGElement;

    if (!chatButton || !chatContainer || !chatEnvelopeIcon || !chatCloseIcon || !chatForm || !closeIcon) {
        console.error("One or more chat elements not found.");
        return;
    }

    // Hide the chat button initially
    chatButton.style.display = "none";

    // Delay showing the chat button after the page has loaded
    setTimeout(() => {
        chatButton.style.display = "block";
        chatForm.classList.add("loaded"); 
    }, 1000); 

    chatButton.addEventListener("click", (event: Event) => {
        event.stopPropagation(); 
        
        const isExpanded = chatButton.getAttribute("aria-expanded") === "true";
        
        chatButton.setAttribute("aria-expanded", String(!isExpanded));
        chatContainer.classList.toggle("visible", !isExpanded);
        chatEnvelopeIcon.style.display = isExpanded ? "block" : "none";
        chatCloseIcon.style.display = isExpanded ? "none" : "block";
    });

    // Click outside to close the chat
    document.addEventListener("click", (event: Event) => {
        if (!chatForm.contains(event.target as Node)) {
            chatButton.setAttribute("aria-expanded", "false");
            chatContainer.classList.remove("visible");
            chatEnvelopeIcon.style.display = "block";
            chatCloseIcon.style.display = "none";
        }
    });

    // Close chat when clicking the close icon
    closeIcon.addEventListener("click", (event: Event) => {
        event.stopPropagation(); // Prevent bubbling to document
        chatButton.setAttribute("aria-expanded", "false");
        chatContainer.classList.remove("visible");
        chatEnvelopeIcon.style.display = "block";
        chatCloseIcon.style.display = "none";
    });

    // Ensure the initial state of icons is correct
    chatEnvelopeIcon.style.display = "block";
    chatCloseIcon.style.display = "none";
});
